/* eslint no-console: ["error", { allow: ["error"] }] */
import { useState, useEffect } from 'react';
import * as contentful from 'contentful';

export const useContentfulEntry = (config, entryId) => {
  const [entry, setEntry] = useState({});
  const client = contentful.createClient(config);

  /*
    We need to gracefully handle the scenario where the component
    unmounts before the request returns data. If we try to set state
    on an unmounted component this will cause a memory leak. This
    implementation follows Dan Abramov's suggestion for avoiding this
    issue using by returning a cleanup function.

    See https://github.com/facebook/react/issues/14326#issuecomment-472043812
  */

  useEffect(() => {
    let requestDidCancel = false;

    const getEntry = async () => {
      try {
        const response = await client.getEntry(entryId);

        if (!requestDidCancel) {
          setEntry(response);
        }
      } catch (err) {
        console.error(`Error retrieving entry ${entryId}.`, err);
      }
    };

    getEntry();

    return () => { requestDidCancel = true; };
  }, [entryId]);

  return entry;
};

export const useContentfulEntries = (config, contentType) => {
  const [entries, setEntries] = useState({});
  const client = contentful.createClient(config);

  useEffect(() => {
    let requestDidCancel = false;

    const getEntries = async () => {
      try {
        const response = await client.getEntries({ content_type: contentType });
        if (!requestDidCancel) setEntries(response);
      } catch (err) {
        console.error(`Error retrieving entries ${contentType}.`, err);
      }
    };

    getEntries();

    return () => { requestDidCancel = true; };
  }, [contentType]);

  return entries;
};
